import { ArrowRight } from "lucide-react";
import "./handler-audition.css";

export function HandlerPromotion({ onContinue }: { onContinue: () => void }) {
  return (
    <section
      className="audition audition-promotion-poster"
      aria-label="Three missions completed"
    >
      <header className="audition-simple-header">
        <h1 className="font-stencil">
          <span>▸</span> Promotion earned <span>◂</span>
        </h1>
      </header>
      <main className="promotion-poster-content">
        <h2 className="promotion-three">
          Three <span>for Three!</span>
        </h2>
        <h2 className="promotion-congratulations">You did it, Agent.</h2>
        <p className="promotion-wins">
          Three missions.
          <br />
          Three straight wins against the enemy.
        </p>
        <div
          className="promotion-completed"
          aria-label="Missions one, two and three completed"
        >
          {[1, 2, 3].map((number) => (
            <div key={number}>
              <span aria-hidden="true">✓</span>
              <small>Mission {number}</small>
            </div>
          ))}
        </div>
        <div className="promotion-score">
          <div>
            <strong>0</strong>
            <span>The enemy</span>
          </div>
          <div>
            <strong>3</strong>
            <span>You</span>
          </div>
        </div>
        <div className="promotion-reward">
          <h2>Choose your Handler</h2>
          <p>
            You’ve shown what you’re made of.
            <br />
            Now it’s time for backup.
          </p>
        </div>
        <button className="promotion-continue" onClick={onContinue}>
          Continue <ArrowRight size={22} />
        </button>
      </main>
    </section>
  );
}
